/**
 * Bouton « Retour » de la page d'un Live School : revient à la page précédente
 * si l'historique le permet, sinon au Feed (onglet Live School) du rôle — un
 * prof, un parent ou un curieux peuvent aussi jouer.
 */
import { ArrowLeft } from 'lucide-react';
import { cn } from '@jeraisonne/ui';
import { useAuth } from '@/lib/auth';

/** Page de repli selon le rôle (Feed de l'espace). */
export function liveBackHref(role: string | null | undefined): string {
  switch (role) {
    case 'student':
      return '/student/news';
    case 'tutor':
    case 'admin':
      return '/tutor/news';
    case 'parent':
      return '/parent/news';
    case 'player':
      return '/player/news';
    default:
      return '/';
  }
}

export function goBackFromLive(role: string | null | undefined): void {
  if (window.history.length > 1) window.history.back();
  else window.location.assign(liveBackHref(role));
}

export function LiveBackButton({
  className,
  variant = 'plain',
}: {
  className?: string;
  /** `overlay` : pastille sombre posée sur la cover. */
  variant?: 'plain' | 'overlay';
}) {
  const { profile } = useAuth();
  return (
    <button
      type="button"
      onClick={() => goBackFromLive(profile?.role)}
      className={cn(
        'inline-flex min-h-11 items-center gap-1.5 text-sm font-medium transition active:scale-[0.98]',
        variant === 'overlay'
          ? 'rounded-full bg-black/40 px-3 text-white backdrop-blur'
          : 'text-ink-500 hover:text-ink-900 self-start',
        className,
      )}
    >
      <ArrowLeft className="h-4 w-4" aria-hidden />
      Retour
    </button>
  );
}
